export var BACKDROP_CLASS_PREFIX = 'Backdrop';